/**
 * client_url para o login Gov.br.
 * Mantém o hash (HashRouter) e remove query para o retorno cair na mesma rota.
 */
export function buildClientUrl(): string {
  const { origin, pathname, hash } = window.location;
  const hashPath = hash.split("?")[0];
  return `${origin}${pathname}${hashPath}`;
}

export function extractSessionId(): string | null {
  const fromSearch = new URLSearchParams(window.location.search).get(
    "session_id",
  );
  if (fromSearch) return fromSearch;

  const hash = window.location.hash;
  const queryStart = hash.indexOf("?");
  if (queryStart >= 0) {
    const fromHash = new URLSearchParams(hash.slice(queryStart + 1)).get(
      "session_id",
    );
    if (fromHash) return fromHash;
  }

  const match = window.location.href.match(/[?&#]session_id=([^&#]+)/);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export function clearSessionIdFromUrl(): void {
  const url = new URL(window.location.href);

  if (url.searchParams.has("session_id")) {
    url.searchParams.delete("session_id");
  }

  if (url.hash.includes("session_id=")) {
    const [hashPath, hashQuery = ""] = url.hash.split("?");
    const params = new URLSearchParams(hashQuery);
    params.delete("session_id");
    const nextQuery = params.toString();
    url.hash = nextQuery ? `${hashPath}?${nextQuery}` : hashPath;
  }

  window.history.replaceState(
    {},
    document.title,
    `${url.pathname}${url.search}${url.hash}` || url.pathname,
  );
}
